import { useEffect, useState } from "react";

import { EncyclopediaChapterLetter } from "./letter/letter";
import { EncyclopediaPhotoBlock } from "./photo_block/photo_block";
import {
	EncyclopediaPageType,
	encyclopediaPageSchema,
} from "../../../schemas/encyclopedia";
import YAML from "yaml";
import { EncyclopediaTextBlock } from "./text_block/text_block";

export const EncyclopediaPage = (props: { pageName: string }) => {
	const [page, changePage] = useState<EncyclopediaPageType>();
	useEffect(() => {
		const getPage = async () => {
			const page = await fetch(
				process.env.PUBLIC_URL +
					`/encyclopedia/pages/${props.pageName}/page.yml`
			).then((r) => (r.ok ? r.text() : null));
			if (page) {
				const parsePage = encyclopediaPageSchema.safeParse(
					YAML.parse(page)
				);
				if (parsePage.success) {
					changePage(parsePage.data);
				} else console.error(parsePage.error);
			}
		};
		getPage();
	}, []);

	return (
		<>
			{page && (
				<div className="page">
					{page.letter && (
						<EncyclopediaChapterLetter letter={page.letter} />
					)}
					<div className="columns">
						{page.columns.map((column, i) => (
							<div key={i} className="column">
								{column.map((item, i) => (
									<div key={i}>
										{item.type === "text-block" && (
											<EncyclopediaTextBlock
												title={item.title}
												content={item.content}
											/>
										)}
										{item.type === "photo-block" && (
											<EncyclopediaPhotoBlock
												images={item.images}
												background={item.background}
											/>
										)}
										{item.type === "image-block" && (
											<img
												className="image_block"
												src={
													process.env.PUBLIC_URL +
													item.image
												}
												alt=""
											/>
										)}
									</div>
								))}
							</div>
						))}
					</div>
				</div>
			)}
		</>
	);
};
